module.exports = __webpack_public_path__ + "img/send.49a63a6d.svg";